import { render, staticRenderFns } from "./UserParamLink.vue?vue&type=template&id=23d79c72&"
import script from "./UserParamLink.vue?vue&type=script&lang=js&"
export * from "./UserParamLink.vue?vue&type=script&lang=js&"
import style0 from "./UserParamLink.vue?vue&type=style&index=0&id=23d79c72&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports